
export interface IUser {
    name?: string;
    FirstName?: string;
    LastName?: string;
    EmployeeId?: number;
    TenantId?: number;
    LogInAs?: boolean;
    AutoLogInAs?: boolean;
    SuperSys?: string;
    Privs?: string;
    CustomerName?: string;
    BranchName?: string;
    Authenticated?: boolean;
}
export class UserDetails implements IUser {
    public name?: string = "";
    public FirstName?: string = "";
    public LastName?: string = "";
    public EmployeeId?: number = -1;
    public TenantId?: number = -1;
    public LogInAs?: boolean = false;
    public AutoLogInAs?: boolean = true;
    public SuperSys?: string = "";
    public Privs?: string = "";
    public CustomerName?: string = "";
    public BranchName?: string = "";
    public Authenticated?: boolean = false;

    public reset() {
        this.name = "";
        this.FirstName = "";
        this.LastName = "";
        this.EmployeeId = -1;
        this.TenantId = -1;
        this.LogInAs = false;
        this.SuperSys = "";
        this.Privs = "";
        this.CustomerName = "";
        this.BranchName = "";
        this.Authenticated = false;
        this.AutoLogInAs = false;
    }
}